import * as actionTypes from '../types/semiProducts';

const initialState = {
  semiProducts: [],
  semiProductsFilled: [],
  error: false,
  loading: false,
  okRequest: false,
  okRequestModal: false,
  loadingModal: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_SEMI_PRODUCTS:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.GET_SEMI_PRODUCTS_SUCCESS:
      return {
        ...state,
        semiProducts: payload,
        semiProductsFilled: payload,
        okRequest: true,
        loading: false
      };
    case actionTypes.GET_SEMI_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.GET_SEMI_PRODUCTS_CLEAR:
      return {
        ...state,
        error: false,
        loading: false,
        okRequest: false,
        okRequestModal: false,
        loadingModal: false
      };
    default:
      return state;
  }
};

export default reducer;
